var chunkMapping = {
	"4207": [
		84207
	],
	"5975": [
		35975
	],
	"6779": [
		36779
	],
	"7543": [
		87543
	],
	"8264": [
		78264
	],
	"8550": [
		78550
	]
};
var idToExternalAndNameMapping = {
	"35975": [
		"default",
		"./pages/selecta",
		74144
	],
	"36779": [
		"default",
		"./store",
		48298
	],
	"78264": [
		"default",
		"./i18n/LangProvider",
		48298
	],
	"78550": [
		"default",
		"./config/context",
		48298
	],
	"84207": [
		"default",
		"./constants/selecta-logos",
		74144
	],
	"87543": [
		"default",
		"./pages/panel",
		48298
	]
};
var idToRemoteMap = {
	"35975": [
		{
			"externalType": "script",
			"name": "selecta",
			"externalModuleId": 74144
		}
	],
	"36779": [
		{
			"externalType": "script",
			"name": "panel",
			"externalModuleId": 48298
		}
	],
	"78264": [
		{
			"externalType": "script",
			"name": "panel",
			"externalModuleId": 48298
		}
	],
	"78550": [
		{
			"externalType": "script",
			"name": "panel",
			"externalModuleId": 48298
		}
	],
	"84207": [
		{
			"externalType": "script",
			"name": "selecta",
			"externalModuleId": 74144
		}
	],
	"87543": [
		{
			"externalType": "script",
			"name": "panel",
			"externalModuleId": 48298
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes = {idToRemoteMap,chunkMapping, idToExternalAndNameMapping, webpackRequire:__webpack_require__};
__webpack_require__.f.remotes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}